import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { buscarTituloCompleto } from '../utils/loaders';
import emptyAnimation from '../assets/empty.json';
import LottieAnimation from '../hooks/getLottie';

export default function HeaderInformativo() {
  const [resultadosBusqueda, setResultadosBusqueda] = useState([]);
  const [busquedaRealizada, setBusquedaRealizada] = useState(false);
  const resultadosRef = useRef(null);
  const timerRef = useRef(null);
  const [cargando, setCargando] = useState(false);
  const PLACEHOLDER_RESULTS = [{ id: 'a1' }, { id: 'b2' }];

  const handleInputChange = (e) => {
    const texto = e.target.value.trim();

    clearTimeout(timerRef.current);

    if (texto.length < 1) {
      setResultadosBusqueda([]);
      setBusquedaRealizada(false);
      return;
    }

    timerRef.current = setTimeout(async () => {
      setCargando(true);
      const resultados = await buscarTituloCompleto(texto);
      setResultadosBusqueda(resultados.data || []);
      setBusquedaRealizada(true);
      setCargando(false);
    }, 300);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (resultadosRef.current && !resultadosRef.current.contains(event.target)) {
        setResultadosBusqueda([]);
        setBusquedaRealizada(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const stripHtmlTags = (input) => input?.replace(/<\/?[^>]+(>|$)/g, '') || '';

  const renderSkeleton = () => (
    <div className="absolute top-20 sm:w-3/6 left-5 sm:left-auto right-5 h-52 bg-white flex items-center justify-center z-30 p-2 shadow border rounded">
      <ul className="w-full h-full animate-pulse" role="status">
        {PLACEHOLDER_RESULTS.map(({ id }) => (
          <li className="flex" key={id}>
            <div className="w-20 h-20 bg-gray-200 p-2 rounded" />
            <div className="w-full pl-2 space-y-1 mt-2">
              <div className="h-2 bg-gray-200 rounded w-3/4" />
              <div className="h-2 bg-gray-200 rounded w-4/6" />
              <div className="h-2 bg-gray-200 rounded w-3/4" />
              <div className="h-2 bg-gray-200 rounded w-2/5" />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );

  const renderListaResultados = () => (
    <div className="absolute top-20 sm:w-3/6 left-5 sm:left-auto right-5 h-60 bg-white z-30 overflow-y-auto p-2 shadow border rounded">
      <ul className="w-full">
        {resultadosBusqueda.map((resultado) => (
          <Link
            to={`/producto/${resultado.titulo}`}
            state={{ id: resultado.id }}
            key={resultado.id}
            className="flex items-center gap-2 p-2 hover:bg-gray-200 cursor-pointer rounded-md"
          >
            <div className="w-20 h-20 flex items-center justify-center bg-gray-200 rounded-md">
              <img src={resultado.imagen_url} alt={resultado.titulo} className="w-20 h-20 object-contain" />
            </div>
            <div className="flex flex-col w-full">
              <h3 className="font-semibold">{resultado.titulo}</h3>
              <p className="text-sm text-gray-500">
                {`${stripHtmlTags(resultado.descripcion).substring(0, 180)}...`}
              </p>
            </div>
          </Link>
        ))}
      </ul>
    </div>
  );

  const renderSinResultados = () => (
    <div className="absolute top-20 sm:w-3/6 left-5 sm:left-auto right-5 h-60 bg-white flex flex-col items-center justify-center z-30 p-2 shadow border rounded">
      <div className="w-40">
        <LottieAnimation animationData={emptyAnimation} />
      </div>
      <p className="text-gray-500 text-center">No se encontraron resultados</p>
    </div>
  );

  return (
    <div className="w-full fondo-formulario">
      <div className="container mx-auto grid grid-cols-4 items-center gap-4 py-4 px-4">
        <div className="col-span-2 hidden sm:flex items-center text-white">
          <p className="font-semibold text-base md:text-xl mr-8">ventas@andes-tec.cl</p>
          <Link to="/contacto">
            <img src="/correo-electronico.svg" alt="Correo" className="w-5" />
          </Link>
        </div>

        <div className="flex group items-center col-span-4 sm:col-span-2 hover:border-blue-400 hover:shadow-2xl duration-200 text-white rounded-md border bg-blue-950/20 relative">
          <FontAwesomeIcon icon={faSearch} className="absolute left-3 text-white" />
          <input
            type="text"
            placeholder="Buscar productos"
            aria-label="Buscar productos Hytera"
            className="w-full bg-blue-950/20 py-2 pl-9 outline-none border-none text-white placeholder-white font-semibold"
            onChange={handleInputChange}
          />
        </div>

        <div ref={resultadosRef}>
          {cargando && renderSkeleton()}
          {!cargando && resultadosBusqueda.length > 0 && renderListaResultados()}
          {!cargando && busquedaRealizada && resultadosBusqueda.length === 0 && renderSinResultados()}
        </div>
      </div>
    </div>
  );
}
